import { supabase } from "../../../supabaseClient";

export async function processVerifiedTeams(eventIds) {
  if (eventIds.length === 0) return true;

  // Get tournament ID from the first event
  const { data: event, error: eventError } = await supabase
    .from("tournamentEvents")
    .select("tournamentID")
    .eq("id", eventIds[0])
    .single();

  if (eventError) throw eventError;

  // Check verification status from the new verification system
  const { data, error } = await supabase
    .from("verificationStates")
    .select("isVerified")
    .eq("tournamentId", event.tournamentID)
    .eq("entityType", "scores");

  if (error) throw error;

  // If no verification state exists yet, return false (not verified)
  if (!data || data.length === 0) {
    return false;
  }

  // If multiple records exist, use the first one (shouldn't happen with proper constraints)
  return data[0]?.isVerified || false;
}
